import {
  voteCompetition,
  voteCompetitionVariables,
  ActionType,
  SocialViewType,
} from '~/graphqls/types'
import { message } from 'antd'
import { useMount } from 'react-use'
import { ValidInfoProps } from '../login/Captcha'
import { useMutation } from '@apollo/client'
import { VOTE_COMPETITION } from '~/graphqls/gqls'
import { graphQLErrorCode, graphQLErrorMessage } from '~/utils'
import { useValidateAuth } from '~/hooks/useValidateAuth'
import React, { useCallback } from 'react'

export const VoteCaptcha: React.FC<{
  productId: number | null | undefined
  onVoteSuccess?: (id: number | null | undefined, vote_num?: number) => void
  children: React.ReactNode
}> = ({ productId, onVoteSuccess, children }) => {
  const captchaId = `get-vote-captcha-${productId}`

  const { validateIsLogin } = useValidateAuth()

  const [voteAction, { loading }] = useMutation<
    voteCompetition,
    voteCompetitionVariables
  >(VOTE_COMPETITION)

  const onVote = useCallback(
    (validInfo?: ValidInfoProps) => {
      return new Promise(resolve => {
        if (validateIsLogin()) {
          if (loading) return
          voteAction({
            variables: {
              param: {
                artworkId: productId,
                actionType: ActionType.CONFIRM,
                viewType: SocialViewType.AI_CREATION,
              },
              checkParam: validInfo,
            },
          })
            .then(res => {
              if (res?.data?.status?.voteAction) {
                onVoteSuccess?.(productId, res?.data?.status?.voteAction)
                resolve(true)
              }
            })
            .catch(err => {
              // 20065500-验证失败, 20065501-需要验证
              if (graphQLErrorCode(err) === 20065501) {
                resolve(false)
                return
              }
              message.destroy()
              if (graphQLErrorCode(err) === 20065500) {
                message.error(graphQLErrorMessage(err) || '验证失败')
                return
              }
              message.error(graphQLErrorMessage(err) || '投票失败')
            })
        }
      })
    },
    [productId]
  )

  const beforeStart = async (next: () => void) => {
    const res = await onVote()
    if (!res) {
      next()
    }
  }

  useMount(() => {
    require('~/plugins/yunpian')

    new YpRiddler({
      expired: 10,
      mode: 'dialog',
      noButton: true,
      winWidth: 400,
      lang: 'zh-cn',
      container: document.getElementById(captchaId),
      appId: '0e790ca2c37d4b3c9aaab7ac0032ea06',
      version: 'v1',
      onError: function (param: { code: number }) {
        message.destroy()
        if (!param.code) {
          message.error('错误请求')
        } else if (Math.floor(param.code / 100) == 5) {
          // 服务不可用时，开发者可采取替代方案
          message.error('验证服务暂不可用')
        } else if (param.code == 429) {
          message.error('请求过于频繁，请稍后再试')
        } else {
          message.error('验证失败，请重试')
        }
      },
      onSuccess: function (validInfo: ValidInfoProps, close: () => void) {
        onVote(validInfo)
        close()
      },
      onFail: function (code: number, msg: string, retry: () => void) {
        retry()
      },
      beforeStart: function (next: () => void) {
        beforeStart(next)
      },
    })
  })

  return <div id={captchaId}>{children}</div>
}
